import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/automation-texts'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'automation_texts_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'automation_texts_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'automation_texts_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
      ],
    },
  ],
};
